import { MessageCircle } from 'lucide-react';

export function ChatFab({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open Friday assistant (⌘J)"
      className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-float transition duration-micro hover:scale-105 active:scale-95"
    >
      <MessageCircle className="h-5 w-5" />
    </button>
  );
}
